export const PET_PP = 'Participant Portal';
export const PET_NF = 'Notifications';

export const enablementTabs = {
  [PET_PP]: 'participantPortal',
  [PET_NF]: 'notifications'
};

export const tabs = [PET_PP, PET_NF];
